import React from 'react';
import classnames from 'classnames';
import { ModuleState } from '@/sunzi';
import Icon from '../../icon';
import styles from './style.less';

export interface HeaderVariantProps {
  modules: ModuleState[];
  current: number;
  onChange?: (current: number) => void;
  onVariantChange?: (id: number) => void;
  onClose: () => void;
}

interface HeaderVariantState {
  expand: boolean;
}

class HeaderVariant extends React.PureComponent<HeaderVariantProps, HeaderVariantState> {
  constructor(props: HeaderVariantProps) {
    super(props);
    this.state = {
      expand: false
    }
  }

  handleExpand = () => {
    const { expand } = this.state;
    this.setState({
      expand: !expand
    });
  }

  /** 切换模块 */
  handleChange = (e: React.MouseEvent, current: number) => {
    e.stopPropagation();
    if (current !== this.props.current && this.props.onChange)
      this.props.onChange(current);
  }

  /** 切换当前模块变体 */
  handleVariantChange = (id: number) => () => {
    this.props.onVariantChange && this.props.onVariantChange(id);
    this.handleExpand();
  }

  render() {
    const { expand } = this.state;
    const { onClose, current, modules } = this.props;
    const currentModule = modules[current];
    const { options = [], optionId } = currentModule;
    const currentOption = options.find(option => option.id === optionId);

    return (
      <div className={styles.variantWrap}>
        <div className={styles.variant}>
          <div id="sunzi-header-close" className={styles.variantClose} onClick={onClose}>
            <Icon type="close" size={30} color="#ff0136" />
          </div>
          <div className={styles.variantContent} onClick={this.handleExpand}>
            <div className={styles.side}>
              <div className={styles.sideName}>{currentModule.name}</div>
              <div className={styles.sideOption}>{currentOption ? currentOption.value : currentModule.description}</div>
            </div>
            <Icon type={expand ? "up" : "down"} />
          </div>
        </div>
        <div 
          className={classnames(styles.variantExpand, expand ? styles.variantExpandOpen : styles.variantExpandClose )} 
          onClick={this.handleExpand}
        >
          <div className={styles.expandTab}>
            {modules.map((item, index) => {
              const itemStyle = classnames(styles.expandTabItem, {
                [styles.expandTabItemActive]: index === current
              });
              return <div key={index} className={itemStyle} onClick={e => this.handleChange(e, index)}>{item.name}</div>;
            })}
          </div>
          <div className={styles.expandVariant}>
            <div key="variant-text" className={styles.expandVariantText}>
              {currentOption ? currentModule.variantText : currentModule.description}
            </div>
            {options.map(item => {
              const active = currentOption && item.id === currentOption.id;
              const itemStyle = classnames(styles.expandVariantItem, {
                [styles.expandVariantItemActive]: active
              });
              return (
                <div key={item.id} className={itemStyle} onClick={this.handleVariantChange(item.id)}>
                  {item.value}
                  {active && <Icon type="check" color="#fff" />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default HeaderVariant;